import { ShiftAuthRequestError } from '../auth/shift-auth.service';
import type { ShiftVacationsQuery } from 'shared-models';
import type {
  ShiftVacation,
  ShiftVacationCreateInput,
  ShiftVacationsResponse,
} from '../../models/vacations.types';

const backendBaseUrl = process.env.REACT_APP_BACKEND_LOCATION ?? '/__shift_api__';

const requestJson = async <T>(path: string, init?: RequestInit): Promise<T> => {
  let response: Response;
  try {
    response = await fetch(`${backendBaseUrl}${path}`, {
      ...init,
      credentials: 'include',
      headers: { 'content-type': 'application/json', ...(init?.headers ?? {}) },
    });
  } catch {
    throw new ShiftAuthRequestError('אין תקשורת לשרת.', 0, true, null);
  }

  const payload = response.headers.get('content-type')?.includes('application/json')
    ? await response.json()
    : null;
  if (!response.ok) {
    const rawMessage = payload?.message;
    const message = Array.isArray(rawMessage)
      ? rawMessage.join(', ')
      : rawMessage || `HTTP ${response.status}`;
    throw new ShiftAuthRequestError(message, response.status, false, payload);
  }
  return payload as T;
};

class ShiftVacationsService {
  async list(query: ShiftVacationsQuery = {}): Promise<ShiftVacationsResponse> {
    const params = new URLSearchParams();
    if (query.offset !== undefined) params.set('offset', String(query.offset));
    if (query.limit !== undefined) params.set('limit', String(query.limit));
    if (query.section) params.set('section', query.section);
    if (query.cursor) params.set('cursor', query.cursor);
    return requestJson<ShiftVacationsResponse>(`/shift/vacations${params.size ? `?${params}` : ''}`);
  }

  async create(payload: ShiftVacationCreateInput): Promise<ShiftVacation> {
    return requestJson<ShiftVacation>('/shift/vacations', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async decide(id: number, decision: 'approved' | 'rejected'): Promise<ShiftVacation> {
    return requestJson<ShiftVacation>(`/shift/vacations/${id}/decision`, {
      method: 'PATCH',
      body: JSON.stringify({ decision }),
    });
  }
}

export const shiftVacationsService = new ShiftVacationsService();
